export const COUNTRY_SHOW_RESET = 'COUNTRY_SHOW_RESET'
export const COUNTRY_SHOW_SET_ERROR = 'COUNTRY_SHOW_SET_ERROR'
export const COUNTRY_SHOW_SET_RETRIEVED = 'COUNTRY_SHOW_SET_RETRIEVED'
export const COUNTRY_SHOW_TOGGLE_LOADING = 'COUNTRY_SHOW_TOGGLE_LOADING'
